import React, { useEffect } from 'react';
import cl from './ShippingPolicy.module.css';
import { animateScroll as scroll } from "react-scroll";



const ShippingPolicy = (props) => {

    useEffect(() => {
      scroll.scrollToTop();
    }, []);

    return (
      <section className={cl.app_policy}>
        <h1>Shipping policy</h1>
        <p>Last updated: February 07, 2024</p>
        <p>
          Our goal is to offer you the best shipping options, no matter where
          you live. We deliver to hundreds of customers across the world every
          day, and we strive to provide you with services of the highest level.
        </p>
        <p>
          We know once you’ve purchased something you are eager to get your
          order as soon as possible. Please see below for more details about the
          shipping policy.
        </p>
        <p>Q: Can you guarantee shipping times?</p>
        <p>
          A: Unfortunately not as these are down to the postal service. We ship
          orders as soon as we are able to when we have received your payment.
          We do not process orders during the weekend or on holidays.
        </p>
        <p>Q: Can I track my order?</p>
        <p>A: Yes! Our service is fully traceable on websites.</p>
        <p>Q: Where do you ship to?</p>
        <p>A: We ship worldwide.</p>
        <p>
          Q: Can I request a refund if my order does not arrive in time for a
          certain date?
        </p>
        <p>
          A: No, we are sorry but we can not refund orders that have already
          been shipped. You may return the order if you wish for a refund
          though.
        </p>
        <p>
          Due to the influence of COVID-19 and the policy restrictions of
          various countries, there will be a big delay in all express
          deliveries, and the logistics cannot guarantee the time limit
          completely.
        </p>
        <p>Delivery time：2-7 days，shipping time：7-15 days</p>
      </section>
    );
}

export default ShippingPolicy;
